
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import PropTypes from 'prop-types'

function CircularProgressWithLabel(props) {
  const theme = useTheme()
  const barColor =
    props?.value < 30
      ? theme.palette.text.warning
      : props?.value >= 30 && props?.value <= 90
      ? theme.palette.text.highlight
      : theme.palette.text.success

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        {...props}
        sx={{
          height: props?.size ?? 10,
          borderRadius: 5,
          color: barColor,
        }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" sx={{ color: 'text.secondary', fontSize: props?.fontSize ?? '' }}>
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  )
}

CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number.isRequired,
}

export default function CircularStatusBar({
  progress,
  size,
  fontSize,
}: {
  progress: number
  size?: number
  fontSize?: number
}) {
  return <CircularProgressWithLabel value={progress ?? 0} size={size} fontSize={fontSize} />
}
